import { ResourceTimelineMessageTypeDto } from '@/api/generated';

export type TimelineMessagesTranslations = {
  button: {
    newEmail: string;
  };
  dialog: {
    removeThreadFromProcess: {
      button: {
        cancel: string;
        confirm: string;
      };
      content: string;
      title: string;
    };
  };
  head: {
    createdFrom: string;
    createdTo: string;
  };
  missingData: string;
  title: string;
  tooltip: {
    removeThreadFromProcess: string;
  };
  type: Record<ResourceTimelineMessageTypeDto, string>;
};

export const timelineMessagesTranslations: TimelineMessagesTranslations = {
  button: {
    newEmail: 'Nowy email',
  },
  dialog: {
    removeThreadFromProcess: {
      button: {
        cancel: 'Anuluj',
        confirm: 'Odłącz',
      },
      content: 'Czy na pewno chcesz odłączyć wątek od procesu?',
      title: 'Odłącz wątek od procesu',
    },
  },
  head: {
    createdFrom: 'Utworzono od',
    createdTo: 'Utworzono do',
  },
  missingData: 'Brak danych',
  title: 'Wiadomości z procesu',
  tooltip: {
    removeThreadFromProcess: 'Odłącz wątek od procesu',
  },
  type: {
    [ResourceTimelineMessageTypeDto.Email]: 'Email',
    [ResourceTimelineMessageTypeDto.Note]: 'Notatka',
  },
};
